import * as SentryOriginal from '@sentry/react'
import type { AxiosError } from 'axios'
import { isAxiosError } from 'axios'

const initSentry = () =>
	SentryOriginal.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		sendDefaultPii: true,
		beforeSend: handleBeforeSend
	})

function handleBeforeSend(event: SentryOriginal.ErrorEvent, hint: SentryOriginal.EventHint) {
	addErrorContextRecursively(event, hint?.originalException)
	return event as SentryOriginal.ErrorEvent
}

function addErrorContextRecursively(event: SentryOriginal.ErrorEvent, error: unknown) {
	if (isAxiosError(error)) {
		addAxiosContext(event, error)
	} else if (error instanceof Error && error.cause) {
		addErrorContextRecursively(event, error.cause)
	}
}

function addAxiosContext(event: SentryOriginal.ErrorEvent, error: AxiosError) {
	if (error.response) {
		const contexts = { ...event.contexts }
		contexts.Axios = { Response: error.response }
		event.contexts = contexts
	}
}

export const Sentry = {
	...SentryOriginal,
	init: initSentry
}
